"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "panicale": {
    "03243adb": [{
      "hkey": "5aed8c7a",
      "slug": "colle-san-paolo",
      "name": "Colle San Paolo",
      "primary": true,
      "skipSearch": false
    }],
    "acquaiola": [{
      "hkey": "5aed8c7a",
      "slug": "colle-san-paolo",
      "name": "Colle San Paolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "panicale"
    }],
    "d507967b": [{
      "hkey": "c709fb8b",
      "slug": "panicale",
      "name": "Panicale",
      "primary": true,
      "skipSearch": false
    }],
    "acquaviva": [{
      "hkey": "c709fb8b",
      "slug": "panicale",
      "name": "Panicale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94fea52a": [{
      "hkey": "4aa28d9b",
      "slug": "mongiovino-vecchio",
      "name": "Mongiovino Vecchio",
      "primary": true,
      "skipSearch": false
    }],
    "mongiovino": [{
      "hkey": "4aa28d9b",
      "slug": "mongiovino-vecchio",
      "name": "Mongiovino Vecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1c76f891": [{
      "hkey": "c709fb8b",
      "slug": "panicale",
      "name": "Panicale",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "c709fb8b",
      "slug": "panicale",
      "name": "Panicale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;